var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',_vm._l((_vm.tags),function(tag){return _c('h5',{key:tag.id + _vm.parentId,staticClass:"float-start margin-right",on:{"click":function($event){return _vm.$emit('selected', tag)}}},[_c('span',{staticClass:"badge",style:(_vm.tagStyle(tag))},[_vm._v(" "+_vm._s(tag.title)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }